import $ from "jquery"
import "slick-carousel"

const Tabs = (containerId) => {
  const container = document.querySelector(`#${containerId}`)
  const $tabs = container.querySelectorAll(`[data-trigger="tabs"]`)
  const $tabsContent = container.querySelectorAll(`.content-tab`)
  const triggerClose = container.querySelectorAll(`[data-trigger-close]`)
  const $tabsButton = container.querySelectorAll(`.tab-button`)

  if ($tabs.length > 0) {
    $tabs.forEach($el => {
      $el.addEventListener(`click`, e => {
        e.preventDefault()
        const target = $el.dataset.target
        const $target = container.querySelector(`#${target.substr(1)}`)
        const changeTitle = $el.parentNode.dataset.changeTitle

        if (!$el.classList.contains(`is-active`)) {
          $tabsContent.forEach(element => {
            element.classList.remove(`visible`)
          })
          $tabs.forEach(element => {
            element.classList.remove(`is-active`)
          })

          let $targetSlider = $(`#${containerId}`).find(`${target}  [data-slick]`)
          $targetSlider.slick(`refresh`)

          if ($el) {
            $el.classList.add(`is-active`)
          }
          if ($target) {
            $target.classList.add(`visible`)
          }

          //Remove button
          $tabsButton.forEach($button => {
            $button.classList.remove(`visible`)
          })
          if (document.getElementById(`${$target.id}-button`)) {
            const buttonToSelect = document.getElementById(
              `${$target.id}-button`
            )

            if (buttonToSelect) {
              buttonToSelect.classList.add(`visible`)
            }
          }
        }

        if (changeTitle === `true`) {
          const value = document.querySelector(`[data-trigger-value]`)
          if (value) {
            value.innerHTML = $el.querySelector(`a`).innerHTML
          }
        }
      })
    })
  }

  if (triggerClose.length > 0) {
    triggerClose.forEach($el => {
      $el.addEventListener(`click`, e => {
        e.preventDefault()
        const target = $el.getAttribute(`data-trigger-close`)
        document.querySelector(`[data-target="#${target}"]`).click()
      })
    })
  }
}



export { Tabs }